import React, {useEffect, useState} from "react";
import styles from "./SpoolStockDirectMainPage.module.css";
import Logo from "../assets/BlackLogo.png";


const SpoolStockDirectMainPage = () => {

    const [stock, setStock] = useState();

    useEffect(() => {
        fetchStock();
    }, [])

    const fetchStock = async () => {
        try {

        const companyId = localStorage.getItem("CID");

        const response = await fetch(
            `https://api-najddsqtfa-uc.a.run.app/company/${companyId}/stock`
        );
        if (!response.ok) return;
        const data = await response.json();

        console.log(data);
        setStock(data);

        } catch (e) {
        console.log("Fetch stock failed:", e.message);
        }
    };



    return (
        <div className={styles.mainContainer}>
            <div className={styles.subContainer}>
                <div className={styles.headerContainer}>
                    <img src={Logo} alt="BrandIt3D" />
                </div>

                <div className={styles.listContainer}>
                    <ul>
                        {stock?.map((product) => (
                            <li className={styles.cardContainer}>
                                <img alt={product.variantName} src={product.variantImage ? product.variantImage : product.productImage} />
                                <div>
                                    <p>{product.vendor}</p>
                                    <h2>{product.variantName}</h2>
                                </div>
            
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}


export default SpoolStockDirectMainPage;